'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/~/dom-helpers/util/inDOM.js
// module id = 1254
// module chunks = 0